import { isEnrollioFormsNavEnabled } from '~shared/utils/is-enrollio-forms-nav-enabled';

export const isActiveSection = (pathname: string, section: string) => {
  const map: Record<string, Array<string>> = {
    dashboard: ['/dashboard', '/new-dashboard'],
    families: ['/parents', '/students'],
    classes: [
      '/classes',
      '/events',
      '/sessions',
      '/room-overview',
      '/class-calendar',
      '/event-calendar',
      '/recitals',
      '/category-config',
    ],
    billing: ['/payment', '/discounts'],
    communications: [
      '/announcements',
      '/outgoing-email-logs',
      '/email-customizer',
      '/email-builder',
      '/email-campaigns',
      '/reminders',
    ],
    reports: ['/payment/payment-reports', '/performance-dashboard'],
    settings: [
      '/studio-profile',
      '/parent-form-config',
      '/parent-portal-link',
      '/policies',
      '/integrations',
      '/drt-integration',
      '/user-management',
      '/audit-logs',
      '/makeup-classes',
      '/trial-bookings',
      '/crm-email-sync',
      '/email-settings',
      '/mobile-inventor-integration',
      '/preflight-check',
      '/public-page-link',
      '/import-data',
      '/import-data-logs',
      '/demo-mode',
      '/v2-mode',
      '/daily-digest',
      '/portal-banner',
      ...(isEnrollioFormsNavEnabled()
        ? ['/forms', '/form-submissions']
        : []),
    ],
    help: [],
  };

  // Reports must win over billing for the shared /payment/payment-reports path.
  if (section === 'billing' && pathname.startsWith('/payment/payment-reports')) {
    return false;
  }

  return map[section]?.some((p) => pathname.startsWith(p)) ?? false;
};
